<div class="{{ form == 'default' ? 'form-group' : 'form-group row flex-nowrap' }} form-group-{{ size }}" [class.disabled]="disabled || formDisabled">
  <label *ngIf="label || form == 'horizontal'" class="{{ form == 'default' ? '' : 'col-lg-auto col-form-label text-lg-end' }} small" [style.width]="labelMaxLength + 'ch'">
    {{label}}
  </label>
  <div class="form-row-content {{ form == 'default' ? '' : 'col d-flex align-items-center' }}">
    <ng-content></ng-content>
  </div>
  <div class="disabled-overlay" (click)="$event.stopPropagation()">
  </div>
</div>